import React from "react";
import { useSelector } from "react-redux";
import { Typography } from "antd";
import { MoreEmptyStatesData } from "./MoreEmptyStatesData";

const { Text } = Typography;

function MoreEmptyState({ type, text, size, button }) {
  const themeDefault = useSelector((state) => state.themeDefault);
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const emptyStatesData = MoreEmptyStatesData;
  const emptyState = emptyStatesData.find((empty) => empty.id === type);

  if (!emptyState) {
    return (
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          width: "100%",
          margin: "20px 0",
        }}
      >
        <Text>Incorrect ID inputted</Text>
      </div>
    );
  }

  const EmptyStateComponent = emptyState.emptyState;
  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        margin: "20px 0",
      }}
    >
      <EmptyStateComponent size={size} />
      <br />
      {text && <Text>{text} </Text>}
      {button && <div style={{ margin: "20px 0" }}>{button}</div>}
    </div>
  );
}

export default MoreEmptyState;
